import React from "react";
import { Link } from "@quintype/components";

import CollectionTitleHeader from "../../molecules/collection-title-header";
import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";
import StoryDate from "../../atoms/story-date";
import { filterStory } from "../../helper/api";
import Separator from "../../atoms/separator";
import PartialCarousel from "../../atoms/carousel-partial";

import "./slider-with-multiple-big-cards.m.css";

const SliderWithMultipleBigCards = ({ collection, index }) => {
  if (!(collection && collection.items)) {
    return null;
  }

  const allStories = filterStory(collection);

  if (!allStories.length) {
    return null;
  }

  const stories = allStories.splice(0, 7);

  const getStory = (item, index) => {
    return (
      <div styleName="story-wrapper" key={index}>
        <Link href={`/${item.slug}`}>
          <CardImage
            story={item}
            aspectRatio={[2, 3]}
            imageType="image2x3"
            widths={[200, 400]}
            sizes="(max-width: 1024px) 100vw, 100vw"
            showVideoIcon={true}
          />
        </Link>
        <Link href={`/${item.slug}`}>
          <Headline text={item.headline} headerType={6} headerLevel={1} story={item} />
        </Link>
        <StoryDate story={item} />
      </div>
    );
  };

  return (
    <>
      <CollectionTitleHeader collection={collection} index={index} />
      <div styleName="border-wrapper">
        <div styleName="wrapper">
          <PartialCarousel length={stories.length} showBullets showArrows>
            {stories.map((item, index) => getStory(item, index))}
          </PartialCarousel>
        </div>
        <Separator />
      </div>
    </>
  );
};

export default SliderWithMultipleBigCards;
